// extracted by mini-css-extract-plugin
export default {"form":"date-input_form__ICmSc","label":"date-input_label__3WZwy","input":"date-input_input__Ey3Dl","pickerWrapper":"date-input_pickerWrapper__Xse1f"};